module.exports = __webpack_public_path__ + "static/media/button1.0cb65328.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/springImage/button1.png
// module id = 964
// module chunks = 0